import styled from 'academy-common-lib/utils/Styling';
export const WidgetWrapper = styled.section.attrs({
  classNames: 'p-x-4 p-y-4 m-x-auto'
}).withConfig({
  displayName: "WidgetWrapper",
  componentId: "sc-1v0jbqr-0"
})(["margin:0 auto;"]);